import { Box, Typography, useTheme } from "@mui/material";

// Rodapé da área logada (mesmo padrão do XC WMS)
const Rodape = () => {
  const theme = useTheme();

  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        textAlign: "center",
        borderTop: `1px solid ${theme.palette.mode === "dark" ? "#423F55" : "#E0E0E0"}`,
        flexShrink: 0,
      }}
    >
      <Typography variant="body2" color="text.primary">
        © 2021 - {new Date().getFullYear()} HelpDesk - XC Soluções. Todos os direitos reservados.
      </Typography>
    </Box>
  );
};

export default Rodape;
